import { put } from 'redux-saga/effects';
import { Creators as UserInfoActions } from '~/store/ducks/userInfo'; 
import Sdk from 'api.digitalpages.module.sdk.api';

export function* getUserInfo() {
  try {
    yield put(UserInfoActions.getSuccess(Sdk.Api.authorization.user));
  } catch (err) {}
}
